import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import Row from './row';
import styled from 'styled-components';
import { colors } from '@grnhse/seedling/lib/azalea/constants';
import type { BulkAction } from './bulk_action';

type Props = {
  bulkActions: Array<BulkAction>;
  cancelAction: (arg1: number) => Promise<any>;
};

function BulkActionList({ bulkActions, cancelAction }: Props) {
  return (
    <List>
      <CSSTransitionGroup
        transitionName="bulk-action"
        transitionLeaveTimeout={200}
        transitionEnterTimeout={200}
      >
        {bulkActions.map((bulkAction) => (
          <Item key={bulkAction.id}>
            <Row bulkAction={bulkAction} cancelAction={cancelAction} />
          </Item>
        ))}
      </CSSTransitionGroup>
    </List>
  );
}

export default BulkActionList;

const List = styled.ul`
  list-style: none;
  border: 0;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  padding: 13px;
  position: relative;

  & + & {
    border-top: 1px solid ${colors.lightGrey};
  }

  transition: opacity 200ms, height 200ms;

  &.bulk-action-leave,
  &.bulk-action-enter.bulk-action-enter-active {
    opacity: 1;
    height: 40px;
  }

  &.bulk-action-leave.bulk-action-leave-active,
  &.bulk-action-enter {
    opacity: 0;
    height: 0;
  }
`;
